// vault-notiz.js — Aufbereitung des Notiztextes vor dem Rendern.

/// Streicht den YAML-Kopf (`---` … `---`) am Dateianfang.
///
/// Obsidian zeigt ihn nicht, unsere Vorschau setzte ihn bis zum 17.09.2026 als
/// Text in die Notiz — „tags:" mit einer Liste darunter stand dann ueber jeder
/// Ueberschrift. Nur ein Block GANZ am Anfang zaehlt; ein `---` mitten im Text
/// ist eine Trennlinie und bleibt.
export function ohneFrontmatter(text) {
  const inhalt = String(text ?? '');
  const treffer = inhalt.match(/^---\r?\n([\s\S]*?)\r?\n---[ \t]*(\r?\n|$)/);
  if (!treffer) return inhalt;
  // Ein zweites `---` im Block waere keine Kopfzeile mehr, sondern Text.
  if (/^\s*---\s*$/m.test(treffer[1])) return inhalt;
  return inhalt.slice(treffer[0].length).replace(/^\r?\n/, '');
}

/// `==text==` → `<mark>text</mark>`, wie Obsidian.
///
/// Bis zum 21.10.2026 hiess das Muster `/==([^=]+)==/`: ein einzelnes `=` in
/// der Markierung (`==Akute Cholezystitis = fehlende Gallenblase==`,
/// `==RVEF <=40%==`) liess das Paar platzen, und ab da war jede weitere
/// Markierung der Notiz verkehrt herum gesetzt. Ausserdem paarte es ueber
/// Zeilen hinweg. Jetzt: einzelnes `=` erlaubt, `==` nicht, keine Zeilenumbrueche,
/// und direkt nach dem oeffnenden `==` steht kein Leerzeichen (`a == b`).
export function markierungen(text) {
  return String(text ?? '').replace(/==(?=[^\s=])((?:[^=\n]|=(?!=))+?)==/g, '<mark>$1</mark>');
}
